/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import mbpLogger from 'mbp-logger';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { makeStyles } from '@material-ui/core/styles';
import findContent from '../../../../../../gql/queries/findContent';
import { isEmpty } from '../../../../../../pages/Account/utils/object';
import { useQuery } from '@apollo/client';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { Box, Link, Button } from '@material-ui/core';
import { icons } from '../../assets/icons';
import RecipientFooter from '../footer/RecipientFooter';

const useStyles = makeStyles((theme) => ({
  RecipientPayItForwordContainer: {
    backgroundColor: theme.palette.thankyoucards.bgColor,
    fontFamily: theme.palette.thankyoucards.typography,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'auto',
    padding: theme.spacing(2),
    '& > svg': {
      margin: '42px 0px 16px 0px',
    },
    '& p': {
      margin: '0px',
      textAlign: 'center',
    },
    '& .mbp-account-MuiButtonBase-root': {
      justifyContent: 'flex-start',
      padding: '14px 14px 14px 26px',
    },
    '& .mbp-account-MuiToggleButton-root:hover': {
      backgroundColor: theme.palette.common.white
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.common.white,
      border: `3px solid ${theme.palette.thankyoucards.primaryColor}!important`,
      animation: '0.3s ease-in',
    },
    '& .mbp-account-MuiToggleButton-root.Mui-selected:hover': {
        backgroundColor: '#FFFFFF'
    },
    '& .mbp-account-MuiToggleButton-root': {
      borderRadius: 'inherit',
      marginBottom: '9px',
      fontFamily: theme.palette.thankyoucards.typography,
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.thankyoucards.primaryColor}`, 
      fontWeight: 400,
      fontSize: '16px',
      color: theme.palette.common.black,
      textTransform: 'capitalize',
    },
    '& .mbp-account-MuiToggleButtonGroup-groupedVertical:not(:first-child)': {
        marginTop: '0px'
    },
    '& .mbp-account-MuiToggleButtonGroup-root': {
      '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
         border: `1px solid ${theme.palette.thankyoucards.primaryColor}`, 
         borderRadius: '3px !important',
      },
      width: '347px',
      '@media screen and (max-width: 375px)': {
         width: '270px',
      },
    },
 },
  specialMessage: {
    fontFamily: theme.palette.thankyoucards.titleTypography,
    fontWeight: 700,
    fontSize: '24px',
    margin: '0',
    lineHeight: '35px',
    textAlign: 'center',
    letterSpacing: '0.01em',
    color: theme.palette.common.black,
  },
  subtitle: {
    fontFamily: theme.palette.thankyoucards.titleTypography,
    fontStyle: 'normal',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '26px',
    letterSpacing: '0.01em',
    color: theme.palette.common.black,
    width: '70%',
    margin: '0 auto',
    textAlign: 'center',
  },
  button: {
    backgroundColor: theme.palette.thankyoucards.primaryColor,
    color: theme.palette.common.white,
    position: 'relative',
    width: '347px',
    height: '53px',
    fontWeight: 700,
    fontSize: '16px',
    textTransform: 'none',
    '@media screen and (max-height: 670px)': {
      fontSize: '14px'
    },
    '&:focus, &:hover, &:active': {
      backgroundColor: theme.palette.thankyoucards.primaryColor,
    },
    '& span': {
      height: 'inherit',
      width: 'inherit'
    },
    '& a': {
      color: theme.palette.common.white,
      textDecoration: 'none!important',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '&:disabled': {
      backgroundColor: theme.palette.colorNeutral50,
      color: theme.palette.common.white,
    },
    '@media screen and (max-width: 375px)': {
      width: '270px',
    },
  },
  scrollBtn: {
    fontFamily: theme.palette.thankyoucards.typography,
    marginTop: '33px',
    marginBottom: '62px',
    color: theme.palette.common.black,
    borderTop: '0',
    borderLeft: '0',
    borderRight: '0',
    borderBottom: `2px solid ${theme.palette.common.black}`,
    padding: '6px 0px 0px 0px',
    fontSize: '14px',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '20px',
    textDecoration: 'none!important',
    background: 'none',
    cursor: 'pointer',
  },
  rotateIcon: {
   '& svg': {
     transform: 'rotate(180deg)',
   }
  },
  showBtn: {
   '&:hover': {
      background: 'none',
   },
   '& svg': {
       fill: theme.palette.thankyoucards.primaryColor,
   },
  }, 
  showMoreOrLess: {
   fontSize: '14px',
   fontWeight: '700',
   textTransform: 'capitalize',
   color: theme.palette.thankyoucards.primaryColor,
   borderBottom: `2px solid ${theme.palette.thankyoucards.primaryColor}`,
   marginRight: '5px',
  },
}));

const RecipientPayItForwardTab = ({ reference, id, cardIsleParams }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subtitle = 'Send a FREE e-card for any occasion in less than 5 minutes!';
  const findContentOptions = {
    brand: 'global',
    contentType: 'template_page_ecards',
  };
  const OCCASIONS_LIST_QUERY = findContent(findContentOptions);
  const { loading, error, data } = useQuery(OCCASIONS_LIST_QUERY);

  const occasionsList = !error && !loading && data ? data.findContent?.content?.entries?.[0]?.ecard_occasion_section : [];
  const recipientmodal = document?.getElementById('recipientmodal')

  const [selectedOccasion, setSelectedOccasion] = useState('');
  const [showMoreBtnClicked, setShowMoreBtnClicked] = useState(false);

  const maxHeight = showMoreBtnClicked ? 'none' : '460px';

  const handleCtaTracking = (category = '', action = '', label = '') => {
   dispatch(trackEvent({
       eventCategory: category,
       eventAction: action,
       eventLabel: label,
   }));
  };
  
  if (error) {
    mbpLogger.logError({
        appName: process.env.npm_package_name,
        query: OCCASIONS_LIST_QUERY,
        jsError: error,
        component: 'RecipientPayItForwordTab.js',
        message: `Failed to fetch content data for: content type ${findContentOptions.contentType} on brand ${findContentOptions.brand}`,
    });
    return (
      <div className={classes.RecipientPayItForwordContainer}>
        <Box mt={4}><p>Oops! Something went wrong, Please try again later!</p></Box>
      </div>
    );
  }

  if (!data) {
    mbpLogger.logWarning({
        appName: process.env.npm_package_name,
        query: OCCASIONS_LIST_QUERY,
        component: 'RecipientPayItForwordTab.js',
        message: 'No data returned for query',
    });
  }

  return (
   <React.Fragment>
    <div id={`section-${id}`} ref={reference} className={classes.RecipientPayItForwordContainer}>
      {icons.payItForwardIcon}
      <p className={classes.specialMessage}>Go ahead - make their day!</p>
      <p className={classes.subtitle}>{subtitle}</p>
      {data && !isEmpty(occasionsList)
        ? (
        <React.Fragment>
          <Box mt={4}>
            <ToggleButtonGroup
              orientation="vertical"
              value={selectedOccasion}
              exclusive
              onChange={(_, nextView) => {
               setSelectedOccasion(nextView);
              }}
              fullWidth
              style={{ maxHeight: maxHeight, overflow: 'hidden' }}
            >
              {occasionsList?.map((occasion) =>
                  occasion.occasion_header === "Sympathy" || occasion.occasion_header === "Pet Sympathy" ? null : (
                     <ToggleButton
                     disableRipple
                     key={occasion.occasion_header}
                     value={occasion.occasion_header}
                     aria-label={occasion.occasion_header}
                     >
                     {occasion.occasion_header}
                     </ToggleButton>
                  )
               )}
            </ToggleButtonGroup>
          </Box>
          {occasionsList?.length > 7
            && (
            <Box my={2}>
               <Button disableRipple className={`${classes.showBtn} ${showMoreBtnClicked ? classes.rotateIcon : ''}`} onClick={() => { showMoreBtnClicked ? setShowMoreBtnClicked(false) : setShowMoreBtnClicked(true); handleCtaTracking('CTA Click', `${showMoreBtnClicked ? 'Show less' : 'Show more'}`); }}>
                   <div className={`${classes.showMoreOrLess}`}>{showMoreBtnClicked ? 'Show less' : 'Show more' }</div>
                   {icons.showMoreIcon}
               </Button>
           </Box>)
          }
          <Box mt={2}>
            <Button
                disableRipple
                disabled={!selectedOccasion}                   
                onClick={() => handleCtaTracking('CTA Click', 'Send E-Card', `Occasion: ${selectedOccasion}`)}
                className={classes.button}>
                  <Link href={`/ecards#${selectedOccasion?.toLowerCase().split(' ').join('-')}`} target="_blank">Send E-Card</Link>
            </Button>
          </Box>
        </React.Fragment>)
        : (<Box mt={4}><p style={{textAlign: 'center'}}>Oops! Free cards are not available at the moment, Please try again later!</p></Box>)
      }
      <button
         onClick={() => recipientmodal.scrollTo({ top: 0, behavior: 'smooth' })}
         className={classes.scrollBtn}>Back To The Top</button>
    </div>
    <RecipientFooter />
   </React.Fragment>
  )
}

export default RecipientPayItForwardTab;